import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { validateFields, validateField } from '../../../../utilities/validation/validator';
import { formatTimeSlots, formatIbcSlots, getFormatDateWithTime } from '../../../../utilities/dateUtils';
import ProviderManager from '../../../../provider/providerManager';
import lodash from 'lodash';

export const getTimeSlots = createAsyncThunk('IBCTechnicianArrivalTime/getTimeSlots', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('getTimeSlots', [data.city, data.cityCode, data.streetCode, data.entrance, data.typeName, '322', data.zipCode, data.captchaToken, '0', '0', '0', '48']);
    return result.Body;
  } catch (error) {
    return error;
  }
});

export const getTimeSlotsFromDate = createAsyncThunk('IBCTechnicianArrivalTime/getTimeSlotsFromDate', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('getTimeSlotsFromDate', [getFormatDateWithTime(data.fromDate), data.city, data.cityCode, data.streetCode, data.entrance, data.typeName, '322', data.zipCode, data.addDays, data.captchaToken, '0', '0', '0']);
    return result.Body;
  } catch (error) {
    return error;
  }
});

export const getIbcTimeSlots = createAsyncThunk('IBCTechnicianArrivalTime/getIbcTimeSlots', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('getIbcTimeSlots', [getFormatDateWithTime(data.fromDate), data.addDays, data.city]);
    return result.Body;
  } catch (error) {
    return error;
  }
});

const IBCTechnicianArrivalTimeSlice = createSlice({
  name: 'ibcTechnicianArrivalTime',
  initialState: {

    form: {
      // address data will come from the user login data , when it will be ready to use
      valid: '',
      timeSlots: [],
      ibcTimeSlots: [],
      arrivalTime: '',
      arrivalStartDate: '',
      arrivalEndDate: '',
      ibcArrivalTime: '',
      ibcArrivalStartDate: '',
      ibcArrivalEndDate: '',
      calendarId: '',
      isLoading: true,
      errorObj: '',
      errors: {},
      rules: {
        arrivalTime: {
          required: { value: true, error: 'לא נבחר מועד' },
        },
      },
    },
  },

  reducers: {
    validateHandler: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const validate = validateFields(lodash.cloneDeep(payload));
        return { payload: validate };
      },
    },
    startLoading: {
      reducer(state, action) {
        const form = { ...state.form };
        form.isLoading = false;
        state['form'] = form;
      },
    },
    clearSlotsList: {
      reducer(state, action) {      
        state.form.timeSlots = action.payload;
      },
    },
    changeHandler: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const name = payload.target.name;
        const value = payload.target.value;
        const form = lodash.cloneDeep(payload.form);

        if (name == 'arrivalTime') {
          form.arrivalStartDate = payload.target.startDate;
          form.arrivalEndDate = payload.target.endDate;
        }
        else {
          form.ibcArrivalStartDate = payload.target.startDate;
          form.ibcArrivalEndDate = payload.target.endDate;
          form.calendarId = payload.target.calendarId;
        }
        const validate = validateField(form, name, value);

        return { payload: validate };
      },
    },
  },
  extraReducers: {
    [getTimeSlots.fulfilled]: (state, action) => {

      if (action.payload.message !== '' && action.payload.message != undefined) {
        state.form.errorObj = { errorId: 0, message: action.payload.message };
      }

      if (action.payload.errorCode != undefined && action.payload.errorCode == 1200) {
        state.form.errorObj = { errorId: 18, message: action.payload.message };
      }

      try {
        state.form.timeSlots = formatTimeSlots(action.payload);
        state.form.isLoading = false;
      } catch (error) {
        state.form.errorObj = { errorId: 0, message: action.payload.message };
      }
    },
    [getTimeSlotsFromDate.fulfilled]: (state, action) => {

      if (action.payload.message !== '' && action.payload.message != undefined) {
        state.form.errorObj = { errorId: 0, message: action.payload.message };
      }

      if (action.payload.errorCode != undefined && action.payload.errorCode == 1200) {
        state.form.errorObj = { errorId: 18, message: action.payload.message };
      }

      try {
        state.form.timeSlots = formatTimeSlots(action.payload);
        state.form.isLoading = false;
      } catch (error) {
        state.form.errorObj = { errorId: 0, message: action.payload.message };
      }
    },
    [getIbcTimeSlots.fulfilled]: (state, action) => {

      if (action.payload.message !== '' && action.payload.message != undefined) {
        state.form.errorObj = { errorId: 42, message: action.payload.message };
      }

      if (action.payload.errorCode != undefined && action.payload.errorCode == 52) {
        state.form.errorObj = { errorId: 42, message: action.payload.message };
      }

      if (action.payload.errorCode != undefined && action.payload.errorCode == 1200) {
        state.form.errorObj = { errorId: 42, message: action.payload.message };
      }

      try {
        state.form.ibcTimeSlots = formatIbcSlots(action.payload.timeSlots);
        state.form.isLoading = false;
      } catch (error) {
        state.form.errorObj = { errorId: 43, message: action.payload.message };
      }
    },
  },
});

export const { changeHandler, validateHandler, startLoading, openPopover, closePopover,clearSlotsList } = IBCTechnicianArrivalTimeSlice.actions;
export default IBCTechnicianArrivalTimeSlice.reducer;
